export const CSH = {
    page: 'customer-shipping-history-page',
    title: 'customer-shipping-history-page__title',
    infoAlert: 'customer-shipping-history-page__info-alert',
    datagrid: 'customer-shipping-history-page__datagrid',
    noRecord: 'customer-shipping-history-page__no-record',
} as const;
